export type OverrideAction = 'buy' | 'transfer' | 'buy_and_transfer';
export type OverrideSide = 'buy' | 'transfer';

/**
 * The override actions a portal offers. The transfer portal locks the action.
 * The buying screen offers Buy or Transfer; choosing Transfer creates the TO
 * immediately (GEN-2873). The combined view also offers Buy + Transfer.
 */
export function overrideActionsFor(
  side: OverrideSide | undefined,
): OverrideAction[] {
  if (side === 'transfer') return [];
  if (side === 'buy') return ['buy', 'transfer'];
  return ['buy', 'transfer', 'buy_and_transfer'];
}
